// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "day-28cYy";
var _3 = "dayOfWeekName-38YAc";
var _4 = "week-nv4Pu";
export { _1 as "__esModule", _2 as "day", _3 as "dayOfWeekName", _4 as "week" }
export default { "__esModule": _1, "day": _2, "dayOfWeekName": _3, "week": _4 }
